<div #outsideModal class="modal">
    <div #modalBody class="modal-content">
        <div class="modal-header"> {{ code }} </div>
        <div class="modal-body">
            <p class="libelle">{{ libelleCode }}</p>
            <form [formGroup]="formGroup" (ngSubmit)="onSubmit()" *ngIf="formGroup">
                <div class="modificateur">
                    <frg-form-input label="Modificateur 1" id="m1" type="ngSelect" [formGroup]="formGroup"
                        [control]="formGroup.get('m1')" [selectValue]="modificateurList"
                        (modelChanged)="onChanged($event, 'm1')" [isClearableSelect]="false">
                    </frg-form-input>
                    <frg-form-input label="Modificateur 2" id="m2" type="ngSelect" [formGroup]="formGroup"
                        [control]="formGroup.get('m2')" [selectValue]="modificateurList"
                        (modelChanged)="onChanged($event, 'm2')" [isClearableSelect]="false">
                    </frg-form-input>
                </div>
                <div class="modificateur">
                    <frg-form-input label="Modificateur 3" id="m3" type="ngSelect" [formGroup]="formGroup"
                        [control]="formGroup.get('m3')" [selectValue]="modificateurList"
                        (modelChanged)="onChanged($event, 'm3')" [isClearableSelect]="false"></frg-form-input>
                    <frg-form-input label="Modificateur 4" id="m4" type="ngSelect" [formGroup]="formGroup"
                        [control]="formGroup.get('m4')" [selectValue]="modificateurList"
                        (modelChanged)="onChanged($event, 'm4')" [isClearableSelect]="false"></frg-form-input>
                </div>
                <frg-form-input label="Code association" id="codeAsso" type="ngSelect" [formGroup]="formGroup"
                    [control]="formGroup.get('codeAsso')" [selectValue]="codeAssoList"
                    (modelChanged)="onChangedAsso($event)"></frg-form-input>
                <div class="price-container">
                    <div class="price-ref-container">
                        <p class="tarif">Tarif de référence</p>
                        <div class="price">{{priceRef}}</div>
                    </div>
                    <div class="price-calc-container">
                        <p class="tarif-calc">Tarif calculé</p>
                        <frg-form-input id="tarifCalc" type="text" [formGroup]="formGroup"
                            [control]="formGroup.get('tarifCalc')">
                        </frg-form-input>
                    </div>
                </div>
                <div class="buttons-wrapper">
                    <frg-button [type]="'button'" [backgroundColor]="'var(--darkest-primary)'"
                        (activated)="closeModificateurModal()">Annuler</frg-button>
                    <frg-button [type]="'submit'">Valider</frg-button>
                </div>
            </form>
        </div>
    </div>
</div>
<div class="modal-background"></div>